import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { accountService, alertService } from "./Services";
import { utils } from "./Helpers/utils";
import { useSearchParams } from "react-router-dom";
import { storageHandler } from "./Helpers";
function SocialCallback({ match }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [paypal, setPaypal] = useState(searchParams.get("paypal"));
  const [pricingsocial, setPricingsocial] = useState(
    searchParams.get("pricingsocial")
  );

  // Safe URL parsing
  // let token = null;
  // try {
  //   const urlParts = window.location.href.split("#");
  //   if (urlParts.length > 1) {
  //     const hashPart = urlParts[1];
  //     const queryPart = hashPart.includes("?")
  //       ? hashPart.split("?")[1]
  //       : hashPart;
  //     const params = Object.fromEntries(new URLSearchParams(queryPart));
  //     token = params["token"];
  //   }
  //   // Fallback to search params if no token in hash
  //   if (!token) {
  //     token = searchParams.get("token");
  //   }
  // } catch (error) {
  //   console.error("Error parsing URL:", error);
  //   token = searchParams.get("token");
  // }

  const referPageUrl = searchParams.get("referalPath");
  const token = searchParams.get("token");
  useEffect(() => {
    if (!token) {
      navigate("/account/login");
      return;
    }

    accountService
      .loginViaToken(token)
      .then((res) => {
        let arrPath = [];
        if (referPageUrl !== null && referPageUrl !== undefined) {
          arrPath = referPageUrl.split("/");
        }

        if (
          res["data"]["roles"][0] &&
          res["data"]["roles"][0]["id"] === 1 &&
          res["data"]["active_role"] === 1
        ) {
          //redirect to landing page.
          let urlToredirect = "";
          if (arrPath.length > 0) {
            if (arrPath[1] === "influencer") {
              urlToredirect = referPageUrl + "?sociallogin=true";
            } else {
              urlToredirect =
                utils.redirectUrl(res.profilestatus)[0] + "?sociallogin=true";
            }
          } else {
            urlToredirect =
              utils.redirectUrl(res.profilestatus)[0] + "?sociallogin=true";
          }

          navigate(urlToredirect);
          //navigate('/influencer/dashboard?sociallogin=true');
        } else if (
          res["data"]["role"] &&
          res["data"]["role"] === "advertiser" &&
          res["data"]["active_role"] === 3
        ) {
          let isFromProfilePage = storageHandler.getUserTypeForProfileItem();
          console.log(isFromProfilePage);
          if (res["data"]["paypalurl"] && paypal !== 1) {
            window.location.replace(res["data"]["paypalurl"]);
          }
          if (pricingsocial === 1) {
            navigate("/brand/influencerdiscovery?success=1");
          }
          if (arrPath.length > 0 && arrPath[1] === "brand") {
            navigate(referPageUrl + "?sociallogin=true");
          } else {
            if (pricingsocial !== 1) {
              navigate("/brand/dashboard?sociallogin=true");
            }
            if (isFromProfilePage !== "") {
              navigate("/brand/influencerdiscovery?sociallogin=true");
            }
          }
          navigate("/brand/dashboard?sociallogin=true");
        } else if (
          res["data"]["role"] &&
          res["data"]["role"] === "admin" &&
          res["data"]["active_role"] === 2
        ) {
          if (arrPath.length > 0 && arrPath[1] === "admin") {
            navigate(referPageUrl + "?sociallogin=true");
          } else {
            navigate("/admin/dashboard?sociallogin=true");
          }
          // navigate('/admin/dashboard?sociallogin=true');
        } else {
          navigate("/account/login");
        }
      })
      .catch((error) => {
        console.error("Login error:", error);
        alertService.error(error);
        navigate("/account/login");
      });
  }, [token]);

  return null;
}

export { SocialCallback };
